const CreamCakeData = [
  {
    productname: "MANGO ALMOND",
    productdescription:
      "Savour the great golden mango rush with fresh plant-based cream",
  },
  {
    productname: "CHOCOLATE TRUFFLE",
    productdescription:
      "Rich chocolate cake covered with rich chocolate mousse and enrobed with liquid chocolate sauce and soya cream",
  },
  {
    productname: "VANILLA",
    productdescription:
      "Vanilla cake baked with plant-based cream and chopped cashews",
  },
  {
    productname: "BLACK FOREST",
    productdescription:
      "Rich chocolate cake with fresh cherries, and a whipped plant-based cream frosting",
  },
  // {
  //   productname: "CARAMEL PISTA",
  //   productdescription:
  //     "Caramel sauce drenched vanilla cake base, covered generously with chopped pistas. This Caramel Pista cream cake is sure to satisfy your sweet cravings",
  // },
  {
    productname: "BUTTER SCOTCH",
    productdescription:
      "Plant-based Butterscotch Cake made from brown sugar topped with butterscotch cream made with melted butterscotch chips",
  },
];
export default CreamCakeData;
